"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GLTFLoader = exports.GLTF_EXTENSIONS = void 0;
var THREE = __importStar(require("../../../externals/three"));
var IGLTF_v2_1 = require("./interfaces/IGLTF_v2");
var MaterialEngine_1 = require("./MaterialEngine");
var GlobalUtilsThreeJs_1 = __importDefault(require("../../../shared/util/GlobalUtilsThreeJs"));
var HttpClient_1 = require("../../../modules/http-client/HttpClient");
var interfaces_1 = require("../../../modules/http-client/interfaces");
var GeometryData_1 = require("./implementation/data/GeometryData");
var MaterialData_1 = require("./implementation/data/MaterialData");
var MaterialPropertiesStandard_1 = require("../../../shared/materials/MaterialPropertiesStandard");
var GLBLoaderSingleton = require("../GLBLoader.js");
var PbrMaterialConverter_1 = require("../../materials/PbrMaterialConverter");
var TextureLoader_1 = __importDefault(require("../TextureLoader"));
var GLTF_EXTENSIONS;
(function (GLTF_EXTENSIONS) {
    GLTF_EXTENSIONS["KHR_BINARY_GLTF"] = "KHR_binary_glTF";
    GLTF_EXTENSIONS["KHR_MATERIALS_PBRSPECULARGLOSSINESS"] = "KHR_materials_pbrSpecularGlossiness";
    GLTF_EXTENSIONS["SHAPEDIVER_MATERIALS_PRESET"] = "SHAPEDIVER_materials_preset";
})(GLTF_EXTENSIONS = exports.GLTF_EXTENSIONS || (exports.GLTF_EXTENSIONS = {}));
var GLTFLoader = /** @class */ (function () {
    function GLTFLoader() {
        // #region Properties (6)
        this.BINARY_EXTENSION_HEADER_LENGTH = 20;
        // private readonly _httpClient: HttpClient = <HttpClient>container.resolve(HttpClient);
        this._materialEngine = MaterialEngine_1.MaterialEngineSingleton;
        this._globalTransformation = new THREE.Matrix4().makeRotationAxis(new THREE.Vector3(1, 0, 0), 0.5 * Math.PI);
        this._loaded = {};
        this._geometryData = [];
        // #endregion Private Methods (9)
    }
    // #endregion Properties (6)
    // #region Public Methods (1)
    GLTFLoader.prototype.loadWithUrl = function (url, transforms, tol, requestHeaders) {
        if (transforms === void 0) { transforms = []; }
        return __awaiter(this, void 0, void 0, function () {
            var axiosResponse, headers, magic, isBinary, binaryGeometry, headerDataView, header, contentDataView, contentDecoded, removeLastDirectoryPartOf;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._loaded = {};
                        this._geometryData = [];
                        headers = {};
                        if (requestHeaders.authorization)
                            headers['Authorization'] = requestHeaders.authorization;
                        return [4 /*yield*/, HttpClient_1.HttpClientInstance.getAsync(url, {
                                responseType: interfaces_1.ResponseType.ArrayBuffer,
                                headers: headers
                            })];
                    case 1:
                        axiosResponse = (_a.sent());
                        magic = new TextDecoder().decode(new Uint8Array(axiosResponse.data, 0, 4));
                        isBinary = magic === 'glTF' || (axiosResponse.headers['content-type'] &&
                            (axiosResponse.headers['content-type'] === 'model/gltf-binary' ||
                                axiosResponse.headers['content-type'] === 'application/octet-stream' ||
                                axiosResponse.headers['content-type'] === 'model/gltf.binary'));
                        if (isBinary) {
                            binaryGeometry = axiosResponse.data;
                            headerDataView = new DataView(binaryGeometry, 0, this.BINARY_EXTENSION_HEADER_LENGTH);
                            header = {
                                magic: magic,
                                version: headerDataView.getUint32(4, true),
                                length: headerDataView.getUint32(8, true),
                                contentLength: headerDataView.getUint32(12, true),
                                contentFormat: headerDataView.getUint32(16, true)
                            };
                            if (header.version != 2)
                                return [2 /*return*/, GLBLoaderSingleton.loadGeometry(url, transforms, tol, requestHeaders)];
                            if (header.magic != 'glTF')
                                throw new Error('GLTFLoader.load: Invalid data: sdgTF magic wrong.');
                            contentDataView = new DataView(binaryGeometry, this.BINARY_EXTENSION_HEADER_LENGTH, header.contentLength);
                            contentDecoded = new TextDecoder().decode(contentDataView);
                            this._content = JSON.parse(contentDecoded);
                            // create body
                            this._body = binaryGeometry.slice(this.BINARY_EXTENSION_HEADER_LENGTH + header.contentLength + 8, header.length);
                        }
                        else {
                            this._content = JSON.parse(new TextDecoder().decode(axiosResponse.data));
                            if (this._content.asset.version !== '2.0')
                                return [2 /*return*/, GLBLoaderSingleton.loadGeometry(url, transforms, tol, requestHeaders)];
                            removeLastDirectoryPartOf = function (the_url) {
                                var dir_char = the_url.includes("/") ? "/" : "\\";
                                var the_arr = the_url.split(dir_char);
                                the_arr.pop();
                                return the_arr.join(dir_char);
                            };
                            this._baseUri = removeLastDirectoryPartOf(url);
                            if (!this._baseUri && window && window.location && window.location.href)
                                this._baseUri = removeLastDirectoryPartOf(window.location.href);
                        }
                        this.validateVersionAndExtensions();
                        return [4 /*yield*/, this.loadScene()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this._geometryData];
                }
            });
        });
    };
    // #endregion Public Methods (1)
    // #region Private Methods (9)
    GLTFLoader.prototype.loadAccessor = function (accessorId) {
        return __awaiter(this, void 0, void 0, function () {
            var accessor, arrayBuffer, itemSize, ArrayType, elementBytes, itemBytes, byteOffset, byteStride, normalized, array, ibSlice, itemSizeIndices, IndicesArrayType, byteOffsetIndices, byteOffsetValues, sparseIndices, _a, sparseValues, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this._content.accessors)
                            throw new Error('Accessors not available.');
                        if (!this._content.accessors[accessorId])
                            throw new Error('Accessor not available.');
                        accessor = this._content.accessors[accessorId];
                        if (this._loaded['accessor'] && this._loaded['accessor'][accessorId])
                            return [2 /*return*/, this._loaded['accessor'][accessorId]];
                        if (accessor.bufferView === undefined) {
                            // Ignore empty accessors, which may be used to declare runtime
                            // information about attributes coming from another source (e.g. Draco
                            // compression extension).
                            return [2 /*return*/, Promise.resolve(null)];
                        }
                        return [4 /*yield*/, this.loadBufferView(accessor.bufferView)];
                    case 1:
                        arrayBuffer = _c.sent();
                        itemSize = IGLTF_v2_1.ACCESSORTYPE[accessor.type];
                        if (accessor.componentType === 5124)
                            console.warn('GLTFLoader.loadAccessor: The componentType for this accessor is 5124, which is not allowed. Trying to load it anyway.');
                        ArrayType = IGLTF_v2_1.ACCESSORCOMPONENTTYPE[accessor.componentType];
                        elementBytes = ArrayType.BYTES_PER_ELEMENT;
                        itemBytes = elementBytes * itemSize;
                        byteOffset = accessor.byteOffset || 0;
                        byteStride = accessor.bufferView !== undefined ? this._content.bufferViews ? this._content.bufferViews[accessor.bufferView].byteStride : undefined : undefined;
                        normalized = accessor.normalized === true;
                        if (byteStride && byteStride !== itemBytes) {
                            ibSlice = Math.floor(byteOffset / byteStride);
                            array = new ArrayType(arrayBuffer, ibSlice * byteStride, accessor.count * byteStride / elementBytes);
                        }
                        else {
                            if (arrayBuffer === null) {
                                array = new ArrayType(accessor.count * itemSize);
                            }
                            else {
                                array = new ArrayType(arrayBuffer, byteOffset, accessor.count * itemSize);
                            }
                        }
                        if (!(accessor.sparse !== undefined)) return [3 /*break*/, 4];
                        itemSizeIndices = IGLTF_v2_1.ACCESSORTYPE.SCALAR;
                        IndicesArrayType = IGLTF_v2_1.ACCESSORCOMPONENTTYPE[accessor.sparse.indices.componentType];
                        byteOffsetIndices = accessor.sparse.indices.byteOffset || 0;
                        byteOffsetValues = accessor.sparse.values.byteOffset || 0;
                        if (!accessor.sparse.indices.bufferView || !accessor.sparse.values.bufferView)
                            throw new Error('Sparse Mesh not properly defined.');
                        _a = IndicesArrayType.bind;
                        return [4 /*yield*/, this.loadBufferView(accessor.sparse.indices.bufferView)];
                    case 2:
                        sparseIndices = new (_a.apply(IndicesArrayType, [void 0, _c.sent(), byteOffsetIndices, accessor.sparse.count * itemSizeIndices]))();
                        _b = ArrayType.bind;
                        return [4 /*yield*/, this.loadBufferView(accessor.sparse.values.bufferView)];
                    case 3:
                        sparseValues = new (_b.apply(ArrayType, [void 0, _c.sent(), byteOffsetValues, accessor.sparse.count * itemSize]))();
                        if (!this._loaded['accessor'])
                            this._loaded['accessor'] = {};
                        this._loaded['accessor'][accessorId] = new GeometryData_1.AttributeData(array, itemSize, itemBytes, byteOffset, elementBytes, normalized, accessor.count, accessor.min, accessor.max, byteStride, true, sparseIndices, sparseValues);
                        return [2 /*return*/, this._loaded['accessor'][accessorId]];
                    case 4:
                        if (!this._loaded['accessor'])
                            this._loaded['accessor'] = {};
                        this._loaded['accessor'][accessorId] = new GeometryData_1.AttributeData(array, itemSize, itemBytes, byteOffset, elementBytes, normalized, accessor.count, accessor.min, accessor.max, byteStride);
                        return [2 /*return*/, this._loaded['accessor'][accessorId]];
                }
            });
        });
    };
    GLTFLoader.prototype.loadBuffer = function (bufferId) {
        return __awaiter(this, void 0, void 0, function () {
            var buffer, dataUriRegex, dataUriRegexResult, result, isBase64, data, view, i, httpResult;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._content.buffers)
                            throw new Error('Buffers not available.');
                        if (!this._content.buffers[bufferId])
                            throw new Error('Buffer not available.');
                        buffer = this._content.buffers[bufferId];
                        if (this._loaded['buffer'] && this._loaded['buffer'][bufferId])
                            return [2 /*return*/, this._loaded['buffer'][bufferId]];
                        if (buffer.type && buffer.type !== 'arraybuffer') {
                            throw new Error("GLTFLoader.loadBuffer: " + buffer.type + " is not supported.");
                        }
                        // If present, GLB container is required to be the first buffer.
                        if (buffer.uri === undefined && bufferId === 0) {
                            if (!this._body)
                                throw new Error("GLTFLoader.loadBuffer: Buffer not available.");
                            return [2 /*return*/, Promise.resolve(this._body)];
                        }
                        dataUriRegex = /^data:(.*?)(;base64)?,(.*)$/;
                        dataUriRegexResult = buffer.uri.match(dataUriRegex);
                        if (!dataUriRegexResult) return [3 /*break*/, 1];
                        isBase64 = !!dataUriRegexResult[2];
                        data = dataUriRegexResult[3];
                        data = decodeURIComponent(data);
                        if (isBase64)
                            data = atob(data);
                        view = new Uint8Array(data.length);
                        for (i = 0; i < data.length; i++) {
                            view[i] = data.charCodeAt(i);
                        }
                        result = view.buffer;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, HttpClient_1.HttpClientInstance.getAsync(this._baseUri + '/' + buffer.uri, {
                            responseType: interfaces_1.ResponseType.ArrayBuffer
                        })];
                    case 2:
                        httpResult = _a.sent();
                        result = (httpResult.data);
                        _a.label = 3;
                    case 3:
                        if (!this._loaded['buffer'])
                            this._loaded['buffer'] = {};
                        this._loaded['buffer'][bufferId] = result;
                        return [2 /*return*/, this._loaded['buffer'][bufferId]];
                }
            });
        });
    };
    GLTFLoader.prototype.loadBufferView = function (bufferViewId) {
        return __awaiter(this, void 0, void 0, function () {
            var bufferView, byteLength, byteOffset, buffer, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._content.bufferViews)
                            throw new Error('BufferViews not available.');
                        if (!this._content.bufferViews[bufferViewId])
                            throw new Error('BufferView not available.');
                        bufferView = this._content.bufferViews[bufferViewId];
                        if (this._loaded['bufferView'] && this._loaded['bufferView'][bufferViewId])
                            return [2 /*return*/, this._loaded['bufferView'][bufferViewId]];
                        byteLength = bufferView.byteLength || 0;
                        byteOffset = bufferView.byteOffset || 0;
                        if (bufferView.buffer === undefined)
                            throw new Error('BufferView has no buffer defined.');
                        return [4 /*yield*/, this.loadBuffer(bufferView.buffer)];
                    case 1:
                        buffer = _a.sent();
                        result = buffer.slice(byteOffset, byteOffset + byteLength);
                        if (!this._loaded['bufferView'])
                            this._loaded['bufferView'] = {};
                        this._loaded['bufferView'][bufferViewId] = result;
                        return [2 /*return*/, this._loaded['bufferView'][bufferViewId]];
                }
            });
        });
    };
    GLTFLoader.prototype.loadMap = function (textureId) {
        return __awaiter(this, void 0, void 0, function () {
            var textureDef, image, sampler, DATA_URI_REGEX, HTTPS_URI_REGEX, texture, bufferView, dataView, array, i, blob, dataUri, url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._content.textures)
                            throw new Error('Textures not available.');
                        textureDef = this._content.textures[textureId];
                        // if (this._loaded['texture'] && this._loaded['texture'][textureId]) return this._loaded['texture'][textureId].clone();
                        if (!this._content.images)
                            throw new Error('Images not available.');
                        image = this._content.images[textureDef.source];
                        sampler = this._content.samplers && textureDef.sampler && this._content.samplers[textureDef.sampler] ? this._content.samplers[textureDef.sampler] : {};
                        DATA_URI_REGEX = /^data:(.*?)(;base64)?,(.*)$/;
                        HTTPS_URI_REGEX = /^https:\/\//;
                        if (!(image.bufferView !== undefined)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.loadBufferView(image.bufferView)];
                    case 1:
                        bufferView = _a.sent();
                        dataView = new DataView(bufferView);
                        array = [];
                        for (i = 0; i < dataView.byteLength; i += 1)
                            array[i] = dataView.getUint8(i);
                        blob = new Blob([new Uint8Array(array)], { type: image.mimeType });
                        dataUri = window.URL.createObjectURL(blob);
                        return [4 /*yield*/, TextureLoader_1.default.loadTexture(dataUri)];
                    case 2:
                        texture = _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        url = DATA_URI_REGEX.test(image.uri) || HTTPS_URI_REGEX.test(image.uri) ? image.uri : this._baseUri + "/" + image.uri;
                        return [4 /*yield*/, TextureLoader_1.default.loadTexture(url)];
                    case 4:
                        texture = _a.sent();
                        _a.label = 5;
                    case 5:
                        if (sampler.minFilter) {
                            texture.minFilter = (function () {
                                switch (sampler.minFilter) {
                                    case MaterialData_1.TEXTURE_FILTERING.NEAREST:
                                        return THREE.NearestFilter;
                                    case MaterialData_1.TEXTURE_FILTERING.NEAREST_MIPMAP_NEAREST:
                                        return THREE.NearestMipMapNearestFilter;
                                    case MaterialData_1.TEXTURE_FILTERING.LINEAR_MIPMAP_NEAREST:
                                        return THREE.LinearMipMapNearestFilter;
                                    case MaterialData_1.TEXTURE_FILTERING.NEAREST_MIPMAP_LINEAR:
                                        return THREE.NearestMipMapLinearFilter;
                                    case MaterialData_1.TEXTURE_FILTERING.LINEAR:
                                        return THREE.LinearFilter;
                                    case MaterialData_1.TEXTURE_FILTERING.LINEAR_MIPMAP_LINEAR:
                                    default:
                                        return THREE.LinearMipMapLinearFilter;
                                }
                            })();
                        }
                        if (sampler.magFilter) {
                            texture.magFilter = (function () {
                                switch (sampler.magFilter) {
                                    case MaterialData_1.TEXTURE_FILTERING.NEAREST:
                                        return THREE.NearestFilter;
                                    case MaterialData_1.TEXTURE_FILTERING.LINEAR:
                                    default:
                                        return THREE.LinearFilter;
                                }
                            })();
                        }
                        if (sampler.wrapS) {
                            texture.wrapS = (function () {
                                switch (sampler.wrapS) {
                                    case 1:
                                        return THREE.ClampToEdgeWrapping;
                                    case 2:
                                        return THREE.MirroredRepeatWrapping;
                                    default:
                                        return THREE.RepeatWrapping;
                                }
                            })();
                        }
                        if (sampler.wrapT) {
                            texture.wrapT = (function () {
                                switch (sampler.wrapT) {
                                    case 1:
                                        return THREE.ClampToEdgeWrapping;
                                    case 2:
                                        return THREE.MirroredRepeatWrapping;
                                    default:
                                        return THREE.RepeatWrapping;
                                }
                            })();
                        }
                        texture.flipY = false;
                        if (!this._loaded['texture'])
                            this._loaded['texture'] = {};
                        this._loaded['texture'][textureId] = texture;
                        return [2 /*return*/, this._loaded['texture'][textureId]];
                }
            });
        });
    };
    GLTFLoader.prototype.loadMaterial = function (materialId) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var material, materialPreset, materialDataV3, materialData, pbrSpecularGlossiness, _c, converter, metallicRoughness, _d, _e, _f, _g;
            var _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (!this._content.materials)
                            throw new Error('Materials not available.');
                        material = this._content.materials[materialId];
                        if (!(material.extensions && material.extensions.SHAPEDIVER_materials_preset)) return [3 /*break*/, 2];
                        materialPreset = material.extensions.SHAPEDIVER_materials_preset;
                        materialDataV3 = new MaterialPropertiesStandard_1.MaterialPropertiesStandard();
                        return [4 /*yield*/, this._materialEngine.loadPresetMaterial(materialPreset.materialpreset, materialDataV3)];
                    case 1:
                        _j.sent();
                        materialDataV3.color = new THREE.Color(GlobalUtilsThreeJs_1.default.toTinyColor(materialPreset.color).toRgbString());
                        return [2 /*return*/, materialDataV3];
                    case 2:
                        materialData = new MaterialPropertiesStandard_1.MaterialPropertiesStandard();
                        if (!(material.extensions && material.extensions.KHR_materials_pbrSpecularGlossiness)) return [3 /*break*/, 5];
                        pbrSpecularGlossiness = material.extensions.KHR_materials_pbrSpecularGlossiness;
                        // materialData.KHR_materials_pbrSpecularGlossiness = true;
                        materialData.color = new THREE.Color('#ffffff');
                        materialData.opacity = 1.0;
                        if (pbrSpecularGlossiness.diffuseFactor !== undefined) {
                            materialData.color = new THREE.Color(GlobalUtilsThreeJs_1.default.toTinyColor([pbrSpecularGlossiness.diffuseFactor[0] * 255, pbrSpecularGlossiness.diffuseFactor[1] * 255, pbrSpecularGlossiness.diffuseFactor[2] * 255]).toRgbString());
                            materialData.opacity = pbrSpecularGlossiness.diffuseFactor[3];
                        }
                        if (!(pbrSpecularGlossiness.diffuseTexture !== undefined)) return [3 /*break*/, 4];
                        _c = materialData;
                        return [4 /*yield*/, this.loadMap(pbrSpecularGlossiness.diffuseTexture.index)];
                    case 3:
                        _c.map = _j.sent();
                        _j.label = 4;
                    case 4:
                        converter = new PbrMaterialConverter_1.PbrMaterialConverter();
                        metallicRoughness = converter.convertToMetallicRoughness({
                            diffuseFactor: (_a = pbrSpecularGlossiness.diffuseFactor) !== null && _a !== void 0 ? _a : [1.0, 1.0, 1.0, 1.0],
                            specularFactor: (_b = pbrSpecularGlossiness.specularFactor) !== null && _b !== void 0 ? _b : [1.0, 1.0, 1.0],
                            glosinessFactor: pbrSpecularGlossiness.glossinessFactor || 1.0
                        });
                        materialData.color = new ((_h = THREE.Color).bind.apply(_h, __spread([void 0], metallicRoughness.baseColor)))();
                        materialData.roughness = metallicRoughness.roughness;
                        materialData.metalness = metallicRoughness.metallic;
                        return [3 /*break*/, 10];
                    case 5:
                        if (!(material.pbrMetallicRoughness !== undefined)) return [3 /*break*/, 10];
                        materialData.color = new THREE.Color('#ffffff');
                        if (material.pbrMetallicRoughness.baseColorFactor !== undefined) {
                            materialData.color = new THREE.Color(GlobalUtilsThreeJs_1.default.toTinyColor([material.pbrMetallicRoughness.baseColorFactor[0] * 255, material.pbrMetallicRoughness.baseColorFactor[1] * 255, material.pbrMetallicRoughness.baseColorFactor[2] * 255]).toRgbString());
                            materialData.opacity = material.pbrMetallicRoughness.baseColorFactor[3];
                        }
                        if (!(material.pbrMetallicRoughness.baseColorTexture !== undefined)) return [3 /*break*/, 7];
                        _d = materialData;
                        return [4 /*yield*/, this.loadMap(material.pbrMetallicRoughness.baseColorTexture.index)];
                    case 6:
                        _d.map = _j.sent();
                        _j.label = 7;
                    case 7:
                        if (material.pbrMetallicRoughness.metallicFactor !== undefined) {
                            materialData.metalness = material.pbrMetallicRoughness.metallicFactor;
                        }
                        if (material.pbrMetallicRoughness.roughnessFactor !== undefined) {
                            materialData.roughness = material.pbrMetallicRoughness.roughnessFactor;
                        }
                        if (!(material.pbrMetallicRoughness.metallicRoughnessTexture !== undefined)) return [3 /*break*/, 10];
                        _e = materialData;
                        return [4 /*yield*/, this.loadMap(material.pbrMetallicRoughness.metallicRoughnessTexture.index)];
                    case 8:
                        _e.metalnessMap = _j.sent();
                        _f = materialData;
                        return [4 /*yield*/, this.loadMap(material.pbrMetallicRoughness.metallicRoughnessTexture.index)];
                    case 9:
                        _f.roughnessMap = _j.sent();
                        _j.label = 10;
                    case 10:
                        if (!(material.normalTexture !== undefined)) return [3 /*break*/, 12];
                        _g = materialData;
                        return [4 /*yield*/, this.loadMap(material.normalTexture.index)];
                    case 11:
                        _g.normalMap = _j.sent();
                        _j.label = 12;
                    case 12:
                        // Note: Not possible in Viewer 2 at the moment
                        // if (material.occlusionTexture !== undefined) {
                        //     materialData.aoMap = await this.loadMap(material.occlusionTexture.index);
                        //     if (material.occlusionTexture.strength !== undefined) {
                        //         materialData.aoMapIntensity = material.occlusionTexture.strength;
                        //     }
                        // }
                        // Note: Not possible in Viewer 2 at the moment
                        // if (material.emissiveTexture !== undefined) {
                        //     materialData.emissiveMap = await this.loadMap(material.emissiveTexture.index);
                        // }
                        // Note: Not possible in Viewer 2 at the moment
                        // if (material.emissiveFactor !== undefined) {
                        //     materialData.emissiveness = new THREE.Color(this._converter.toColor([material.emissiveFactor[0] * 255, material.emissiveFactor[1] * 255, material.emissiveFactor[2] * 255]));
                        // }
                        if (material.alphaMode !== undefined) {
                            if (material.alphaMode.toLowerCase() === MaterialData_1.MATERIAL_ALPHA.BLEND) {
                                materialData.transparent = true;
                            }
                            else if (material.alphaMode.toLowerCase() === MaterialData_1.MATERIAL_ALPHA.MASK) {
                                materialData.alphaTest = material.alphaCutoff !== undefined ? material.alphaCutoff : 0.5;
                            }
                        }
                        // Note: Not possible in Viewer 2 at the moment
                        // if (material.alphaCutoff !== undefined) {
                        //     materialData.alphaCutoff = material.alphaCutoff;
                        // }
                        if (material.doubleSided !== undefined) {
                            materialData.side = material.doubleSided ? THREE.DoubleSide : THREE.FrontSide;
                        }
                        return [2 /*return*/, materialData];
                }
            });
        });
    };
    GLTFLoader.prototype.loadMesh = function (meshId, name, matrix) {
        return __awaiter(this, void 0, void 0, function () {
            var mesh, meshName, i, len;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._content.meshes)
                            throw new Error('Meshes not available.');
                        if (!this._content.meshes[meshId])
                            throw new Error('Mesh not available.');
                        mesh = this._content.meshes[meshId];
                        meshName = name + '_mesh_' + meshId;
                        if (!mesh.primitives) return [3 /*break*/, 4];
                        i = 0, len = mesh.primitives.length;
                        _a.label = 1;
                    case 1:
                        if (!(i < len)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.loadPrimitive(mesh.primitives, i, meshName, matrix)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    GLTFLoader.prototype.loadNode = function (nodeId, name, matrix) {
        return __awaiter(this, void 0, void 0, function () {
            var node, nodeName, transformationMatrix, matT, matR, matS, i, len;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._content.nodes)
                            throw new Error('Nodes not available.');
                        if (!this._content.nodes[nodeId])
                            throw new Error('Node not available.');
                        node = this._content.nodes[nodeId];
                        nodeName = name + '_node_' + nodeId;
                        transformationMatrix = new THREE.Matrix4();
                        if (node.matrix) {
                            transformationMatrix.fromArray(node.matrix);
                        }
                        else if (node.translation || node.scale || node.rotation) {
                            matT = node.translation ? new THREE.Matrix4().makeTranslation(node.translation[0], node.translation[1], node.translation[2]) : new THREE.Matrix4();
                            transformationMatrix.multiply(matT);
                            matR = node.rotation ? new THREE.Matrix4().makeRotationFromQuaternion(new THREE.Quaternion().set(node.rotation[0], node.rotation[1], node.rotation[2], node.rotation[3])) : new THREE.Matrix4();
                            transformationMatrix.multiply(matR);
                            matS = node.scale ? new THREE.Matrix4().makeScale(node.scale[0], node.scale[1], node.scale[2]) : new THREE.Matrix4();
                            transformationMatrix.multiply(matS);
                        }
                        transformationMatrix = matrix.clone().multiply(transformationMatrix);
                        if (!(node.mesh !== undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadMesh(node.mesh, nodeName, transformationMatrix.clone())];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!node.children) return [3 /*break*/, 6];
                        i = 0, len = node.children.length;
                        _a.label = 3;
                    case 3:
                        if (!(i < len)) return [3 /*break*/, 6];
                        // got through all children
                        return [4 /*yield*/, this.loadNode(node.children[i], nodeName, transformationMatrix.clone())];
                    case 4:
                        // got through all children
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        i++;
                        return [3 /*break*/, 3];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    GLTFLoader.prototype.loadPrimitive = function (primitives, index, name, matrix) {
        return __awaiter(this, void 0, void 0, function () {
            var primitive, primitiveName, attributes, _a, _b, _i, attribute, attributeName, index_1, _c, _d, indices, material;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        primitive = primitives[index];
                        primitiveName = name + '_primitive_' + index;
                        attributes = {};
                        _a = [];
                        for (_b in primitive.attributes)
                            _a.push(_b);
                        _i = 0;
                        _e.label = 1;
                    case 1:
                        if (!(_i < _a.length)) return [3 /*break*/, 4];
                        attribute = _a[_i];
                        attributeName = attribute;
                        if (/\d/.test(attributeName) && !attributeName.includes('_')) {
                            index_1 = attributeName.search(/\d/);
                            attributeName = attributeName.substring(0, index_1) + '_' + attributeName.substring(index_1, attributeName.length);
                        }
                        else if (attributeName === 'TEXCOORD' || attributeName === 'COLOR' || attributeName === 'JOINTS' || attributeName === 'WEIGHTS') {
                            attributeName += '_0';
                        }
                        else if (attributeName === 'UV') {
                            attributeName = 'TEXCOORD_0';
                        }
                        _c = attributes;
                        _d = attributeName;
                        return [4 /*yield*/, this.loadAccessor(primitive.attributes[attribute])];
                    case 2:
                        _c[_d] = (_e.sent());
                        _e.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        indices = null;
                        if (!(primitive.indices || primitive.indices === 0)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.loadAccessor(primitive.indices)];
                    case 5:
                        indices = _e.sent();
                        _e.label = 6;
                    case 6:
                        material = null;
                        if (!(primitive.material || primitive.material === 0)) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.loadMaterial(primitive.material)];
                    case 7:
                        material = _e.sent();
                        _e.label = 8;
                    case 8:
                        this._geometryData.push({
                            path: primitiveName,
                            geometry: this.loadGeometry(new GeometryData_1.PrimitiveData(attributes, primitive.mode, indices, material)),
                            material: material || new MaterialPropertiesStandard_1.MaterialPropertiesStandard(),
                            initialMatrix: matrix.clone(),
                            type: "mesh"
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    GLTFLoader.prototype.loadGeometry = function (primitive) {
        var geometry = new THREE.BufferGeometry();
        for (var attributeId in primitive.attributes) {
            var bufferAttribute = primitive.attributes[attributeId];
            var buffer = void 0;
            if (bufferAttribute.byteStride && bufferAttribute.byteStride !== bufferAttribute.itemBytes) {
                // Integer parameters to IB/IBA are in array elements, not bytes.
                var ib = new THREE.InterleavedBuffer(bufferAttribute.array, bufferAttribute.byteStride / bufferAttribute.elementBytes);
                buffer = new THREE.InterleavedBufferAttribute(ib, bufferAttribute.itemSize, (bufferAttribute.byteOffset % bufferAttribute.byteStride) / bufferAttribute.elementBytes, bufferAttribute.normalized);
            }
            else {
                buffer = new THREE.BufferAttribute(bufferAttribute.array, bufferAttribute.itemSize, (attributeId === 'COLOR_0' || attributeId === 'COLOR0' || attributeId === 'COLOR') ? true : bufferAttribute.normalized);
            }
            if (bufferAttribute.sparse) {
                if (bufferAttribute.array !== null) {
                    // Avoid modifying the original ArrayBuffer, if the bufferView wasn't initialized with zeroes.
                    buffer = new THREE.BufferAttribute(bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized);
                }
                for (var i = 0, il = bufferAttribute.sparseIndices.length; i < il; i++) {
                    var index = bufferAttribute.sparseIndices[i];
                    buffer.setX(index, bufferAttribute.sparseValues[i * bufferAttribute.itemSize]);
                    if (bufferAttribute.itemSize >= 2)
                        buffer.setY(index, bufferAttribute.sparseValues[i * bufferAttribute.itemSize + 1]);
                    if (bufferAttribute.itemSize >= 3)
                        buffer.setZ(index, bufferAttribute.sparseValues[i * bufferAttribute.itemSize + 2]);
                    if (bufferAttribute.itemSize >= 4)
                        buffer.setW(index, bufferAttribute.sparseValues[i * bufferAttribute.itemSize + 3]);
                    if (bufferAttribute.itemSize >= 5) {
                        throw new Error("GeometryLoader.loadGeometry: Unsupported itemSize in sparse BufferAttribute.");
                    }
                }
            }
            if (attributeId === 'NORMAL') {
                var blnNormalsOk = false;
                for (var index = 0; index < 10; ++index) {
                    if (Math.abs(bufferAttribute.array[index * 3]) > 0.001) {
                        blnNormalsOk = true;
                        break;
                    }
                    if (Math.abs(bufferAttribute.array[index * 3 + 1]) > 0.001) {
                        blnNormalsOk = true;
                        break;
                    }
                    if (Math.abs(bufferAttribute.array[index * 3 + 2]) > 0.001) {
                        blnNormalsOk = true;
                        break;
                    }
                }
                if (!blnNormalsOk) {
                    geometry.computeVertexNormals();
                    var computedNormalAttribute = geometry.getAttribute('normal');
                    // store the computed normals in the attribute data
                    primitive.attributes[attributeId] = new GeometryData_1.AttributeData(new Float32Array(computedNormalAttribute.array), computedNormalAttribute.itemSize, 0, 0, 3, computedNormalAttribute.normalized, computedNormalAttribute.array.length / 3);
                    continue;
                }
            }
            switch (attributeId) {
                case 'POSITION':
                    geometry.addAttribute('position', buffer);
                    break;
                case 'NORMAL':
                    geometry.addAttribute('normal', buffer);
                    break;
                case 'TEXCOORD_0':
                case 'TEXCOORD0':
                case 'TEXCOORD':
                case 'UV':
                    geometry.addAttribute('uv', buffer);
                    break;
                case 'TEXCOORD_1':
                    geometry.addAttribute('uv2', buffer);
                    break;
                case 'COLOR_0':
                case 'COLOR0':
                case 'COLOR':
                    geometry.addAttribute('color', buffer);
                    break;
                case 'WEIGHT':
                    //geometry.addAttribute('skinWeight', buffer);
                    break;
                case 'JOINT':
                    //geometry.addAttribute('skinIndex', buffer);
                    break;
                case 'TANGENT':
                    geometry.addAttribute('tangent', buffer);
                    break;
                default:
                    console.warn("GeometryLoader.loadGeometry: Unrecognized attribute id " + attributeId + ".");
            }
            if (primitive.indices)
                geometry.setIndex(new THREE.BufferAttribute(primitive.indices.array, primitive.indices.itemSize));
        }
        return geometry;
    };
    GLTFLoader.prototype.validateVersionAndExtensions = function () {
        if (!this._content.asset)
            throw new Error('Asset not available.');
        var asset = this._content.asset;
        if (!asset.version)
            throw new Error('Asset does not have a version.');
        var version = asset.minVersion ? asset.minVersion : asset.version;
        if (!version.startsWith('2'))
            throw new Error('Version of the glTF not supported.');
        if (this._content.extensionsUsed) {
            var notSupported_1 = [];
            for (var i = 0; i < this._content.extensionsUsed.length; i++) {
                if (!Object.values(GLTF_EXTENSIONS).includes(this._content.extensionsUsed[i]))
                    notSupported_1.push(this._content.extensionsUsed[i]);
            }
            if (notSupported_1.length > 0) {
                var message_1 = 'Extension' + (notSupported_1.length === 1 ? ' ' : 's ');
                notSupported_1.forEach(function (element, index) {
                    message_1 += '"' + element + '"' + (index === notSupported_1.length - 1 ? '' : index === notSupported_1.length - 2 ? ' and ' : ', ');
                });
                message_1 += (notSupported_1.length === 1 ? ' is' : ' are') + ' not supported, but used. Loading glTF regardless.';
                console.info('GLTFLoader.validateVersionAndExtensions: ' + message_1);
            }
        }
        if (this._content.extensionsRequired) {
            var notSupported_2 = [];
            for (var i = 0; i < this._content.extensionsRequired.length; i++) {
                if (!Object.values(GLTF_EXTENSIONS).includes(this._content.extensionsRequired[i]))
                    notSupported_2.push(this._content.extensionsRequired[i]);
            }
            if (notSupported_2.length > 0) {
                var message_2 = 'Extension' + (notSupported_2.length === 1 ? ' ' : 's ');
                notSupported_2.forEach(function (element, index) {
                    message_2 += '"' + element + '"' + (index === notSupported_2.length - 1 ? '' : index === notSupported_2.length - 2 ? ' and ' : ', ');
                });
                message_2 += (notSupported_2.length === 1 ? ' is' : ' are') + ' not supported, but required. Aborting glTF loading.';
                throw new Error(message_2);
            }
        }
    };
    GLTFLoader.prototype.loadScene = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sceneID, scene, i, len;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._content.scenes)
                            throw new Error('Scenes not available.');
                        sceneID = this._content.scene || 0;
                        if (!this._content.scenes[sceneID])
                            throw new Error('Scene not available.');
                        scene = this._content.scenes[sceneID];
                        if (!scene.nodes) return [3 /*break*/, 4];
                        i = 0, len = scene.nodes.length;
                        _a.label = 1;
                    case 1:
                        if (!(i < len)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.loadNode(scene.nodes[i], 'scene_' + sceneID, this._globalTransformation.clone())];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return GLTFLoader;
}());
exports.GLTFLoader = GLTFLoader;
